 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"default~features-public-pages-public-page-module~features-supplier-portal-pages-navigation-parent-te~d4986a96":"default~features-public-pages-public-page-module~features-supplier-portal-pages-navigation-parent-te~d4986a96","features-supplier-portal-pages-navigation-parent-template-module":"features-supplier-portal-pages-navigation-parent-template-module","default~features-public-pages-public-page-module~hosts-hosts-module~invitations-invitations-module~i~61aad2a1":"default~features-public-pages-public-page-module~hosts-hosts-module~invitations-invitations-module~i~61aad2a1","default~features-public-pages-public-page-module~hosts-hosts-module~invoices-invoices-module~organis~50e8b264":"default~features-public-pages-public-page-module~hosts-hosts-module~invoices-invoices-module~organis~50e8b264","features-public-pages-public-page-module":"features-public-pages-public-page-module","dashboard-dashboard-module":"dashboard-dashboard-module","default~hosts-hosts-module~invitations-invitations-module~invoices-invoices-module~master-product-ma~d561dad8":"default~hosts-hosts-module~invitations-invitations-module~invoices-invoices-module~master-product-ma~d561dad8","default~hosts-hosts-module~invitations-invitations-module~organisations-organisations-module~product~137762ab":"default~hosts-hosts-module~invitations-invitations-module~organisations-organisations-module~product~137762ab","common":"common","organisations-organisations-module":"organisations-organisations-module","users-users-module":"users-users-module","default~hosts-hosts-module~invoices-invoices-module~master-product-master-product-module~products-pr~98fd2e62":"default~hosts-hosts-module~invoices-invoices-module~master-product-master-product-module~products-pr~98fd2e62","default~hosts-hosts-module~invoices-invoices-module":"default~hosts-hosts-module~invoices-invoices-module","hosts-hosts-module":"hosts-hosts-module","default~master-product-master-product-module~products-products-module~promotions-promotions-module":"default~master-product-master-product-module~products-products-module~promotions-promotions-module","promotions-promotions-module":"promotions-promotions-module","products-products-module":"products-products-module","default~invoices-invoices-module~profiles-profiles-module":"default~invoices-invoices-module~profiles-profiles-module","profiles-profiles-module":"profiles-profiles-module","invoices-invoices-module":"invoices-invoices-module","invitations-invitations-module":"invitations-invitations-module","master-product-master-product-module":"master-product-master-product-module","canvg":"canvg","dompurify":"dompurify","html2canvas":"html2canvas"}[chunkId]||chunkId) + "-es2015." + {"default~features-public-pages-public-page-module~features-supplier-portal-pages-navigation-parent-te~d4986a96":"5ef86b9fa82866f581a4","features-supplier-portal-pages-navigation-parent-template-module":"a69642abf0adc67cc0a4","default~features-public-pages-public-page-module~hosts-hosts-module~invitations-invitations-module~i~61aad2a1":"c9dc128ce319dc2e48e4","default~features-public-pages-public-page-module~hosts-hosts-module~invoices-invoices-module~organis~50e8b264":"94f173fab2c09e4f8f9e","features-public-pages-public-page-module":"e8a043a4b7c4cb4925af","dashboard-dashboard-module":"5301b32a9b2b19f469c6","default~hosts-hosts-module~invitations-invitations-module~invoices-invoices-module~master-product-ma~d561dad8":"e6e32a4eaa5327b9e0ff","default~hosts-hosts-module~invitations-invitations-module~organisations-organisations-module~product~137762ab":"c683aff935b71091dd1c","common":"46c8529c701ac4f1b629","organisations-organisations-module":"db18b41adddf25af9254","users-users-module":"d04a9e297e037f347199","default~hosts-hosts-module~invoices-invoices-module~master-product-master-product-module~products-pr~98fd2e62":"01b3b87f973a6c086c67","default~hosts-hosts-module~invoices-invoices-module":"68b44c4bb47d6278e533","hosts-hosts-module":"0e2c48390e8781537925","default~master-product-master-product-module~products-products-module~promotions-promotions-module":"308e65207178f2dcdb1e","promotions-promotions-module":"e50cf1dccc048f7a9fcc","products-products-module":"6459cf33be0ef73a2e21","default~invoices-invoices-module~profiles-profiles-module":"76026e563155044fc793","profiles-profiles-module":"de347b509ec24222ef25","invoices-invoices-module":"c18dcf0bb1b99a62f375","invitations-invitations-module":"6cf0bc298ec1244b0714","master-product-master-product-module":"ac7fe04dc92a206c370f","canvg":"5a43d187e4f94fe53291","dompurify":"7828f6d5f92a1ae8f821","html2canvas":"d175bde72f99fda8af15"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
